import { MODALS } from 'common/domain/constants';
import { MODAL_STATES } from 'food-benefit.module/common/domain/constants';
import moment from 'moment';

class BenefitRequestModalController {
  constructor($translate) {
    'ngInject';
    this.translate = $translate;
    this.$modal = $(MODALS.BENEFIT_REQUEST_LIST);
    this.message = '';
    this._translate();
    this.isModalBodyScrollable = false;
  }

  $onInit() {
    moment.locale('es');
    this._loadErrorMsg();
    if(this.isMobileApp) {
      this.isModalBodyScrollable = true;
    }
  }

  _loadErrorMsg() {
    this.translate('FOOD_BENEFIT.BENEFIT_REQUEST_CARD.REQUEST_DENIED_MSG').then((translation) => {
      this.errorMsg = this.errorMsg || translation;
    });
  }

  isManagerApprovingAll() {
    return this.modalState === MODAL_STATES.managerListConfirmAll;
  }

  isManagerRejecting() {
    if (!this.request) return;
    this.formatMonthToBind();
    return this.modalState === MODAL_STATES.isManagerRejecting;
  }

  isUserSendingAllCards() {
    return this.modalState === MODAL_STATES.isSendingAllCards;
  }

  isDelegated () {
    return this.modalState === MODAL_STATES.isDelegated;
  }

  formatMonthToBind() {
    moment.locale('es');
    let dateToGetMonth = new Date(this.request.enjoymentYear,
      this.request.enjoymentMonth - 1);
    this.monthName = moment(dateToGetMonth).format('MMMM');
  }

  isApproved() {
    return this.modalState === MODAL_STATES.approve;
  }

  isApprovedReject() {
    return this.modalState === MODAL_STATES.approveReject;
  }

  isFailed() {
    return this.modalState === MODAL_STATES.failed;
  }

  _translate() {
    this.translate('FOOD_BENEFIT.MODAL_REJECT_REQUEST.JOURNEYS').then((translation) => {
      this.msgString = translation;
    });

    this.translate('FOOD_BENEFIT.MODAL_APPROVE_ALL.OK').then((translation) => {
      this.allRequestApprovedText = translation;
    });
  }
}

export default BenefitRequestModalController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/benefitRequestModal/benefitRequestModal.controller.js